module.exports = __webpack_public_path__ + "img/sql.17db5879.svg";